import { StringDictionary } from "@k/js/delme_globals";
import {ArtikelStoreWrapper} from "@km/components/artikel/artikelStoreWrapper";
import {Store, useStore} from "vuex";
import {ArtikelInfoHandler} from "./artikelInteractorVue";
import {ArtikelInfo, ArtikelBilder} from "./artikelInterfaces";

export class VueXArtikelStoreWrapper implements ArtikelStoreWrapper {
    private store: Store<any>;

    public constructor() {
        this.store = useStore();
    }

    getArtikelInfos = () => {
        return this.store.getters.getArtikelInfo.artikelInfos;
    };
    getArtikelBilder = () => this.store.getters.getArtikelInfo.artikelBilder;
    getActiveArtikel: () => ArtikelInfoHandler;
    getSelectedColor: () => string;
    getSelectedSize: () => string;

    getArtikelInfo() {
        return this.store.getters.getArtikelInfo;
    }
    getWebsportFuerProduktAuswahlNormalized() {

        return  this.store.getters["ModelStore/getWebsportFuerProduktAuswahlNormalized"];
    }
    getSprache() {

        return this.store.getters["ModelStore/getSprache"];
    }
    closeArtikelView() {
        this.store.commit("CLOSE_ARTIKELVIEW")
    }

}